import { Tooltip } from 'antd';
import { t } from 'i18next';

import { ENV_VARS } from '@/env';

import { USER_PREFERENCES } from '../../../../../contants/common';
import useUserPreference from '../../../../../redux/hooks/useUserPreference';
import Button from '../../../../components/Buttons/Button';
import FormLabel from '../../../../components/Labels/FormLabel';
import SecondaryLabel from '../../../../components/Labels/SecondaryLabel';
import { convertToTimeZone } from '../../../Shipment/components/QuoteCard/components/QuoteDetails/utils';

const isHalliburton = ENV_VARS.REACT_APP_THEME === 'halliburton';

export const BidDurationCard = ({
  dateValue,
  isConvertTZ,
  canChangeBidExpiration = true,
  isResetBidExpiration = false,
}) => {
  const userDateFormat = useUserPreference(USER_PREFERENCES.DEFAULT_DATE_FORMAT) || 'MM/DD/YYYY';

  const displayValue = isConvertTZ ? convertToTimeZone(dateValue) : dateValue;

  return (
    <>
      <FormLabel>{t('translation:getQuote.quoteDetails.bidExpiration.label')}</FormLabel>
      <Tooltip placement="bottom" title={canChangeBidExpiration ? 'Click to change Bid Duration' : ''}>
        {dateValue && !isResetBidExpiration ? (
          <div>
            <SecondaryLabel className="f-14 fw-600 text-dark">
              {displayValue.format(`${userDateFormat} | hh:mm:ss A`)}
            </SecondaryLabel>
          </div>
        ) : (
          <Button
            disabled={!canChangeBidExpiration}
            fullWidth
            type="default"
            style={{ maxWidth: '200px' }}
            dataTestId="set-bid-expiration"
            className={isHalliburton ? 'hb-button' : ''}
          >
            Set Bid Expiration
          </Button>
        )}
      </Tooltip>
    </>
  );
};
